// extracted by mini-css-extract-plugin
export default {"main":"liked_main__VdJS4"};